import axios from 'axios'

const baseURL = import.meta.env.VITE_VOUCHERS_API_BASE_URL

const apiInstance = axios.create({
  baseURL: `${baseURL}`
})

export default apiInstance
